module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab16/awsop-lab16.component.css
// module id = ./src/app/course/labs/awsop/awsop-lab16/awsop-lab16.component.css
// module chunks = main